import request from "../utils/request";
import qs from "qs";
import { get } from "core-js/core/dict";

// export const fetchData = query => {
//     return request({
//         url: './table.json',
//         method: 'get',
//         params: query
//     });
// }

export function getData(param) {
  return request({
    url:
      "/api/consumer/hmPayScreen/getHmPayOriginSummary?" + qs.stringify(param),
    method: "get",
  });
}
export function getData1(dateStart, dateEnd) {
  return request({
    url:
      "/api/consumer/hmPayScreen/getHmPayOriginSummary?" +
      "dateStart=" +
      dateStart +
      "&dateEnd=" +
      dateEnd,
    method: "get",
  });
}

export function getUser() {
  return request({
    url: "/user/getUser",
    method: "get",
  });
}

export function dump() {
  return request({
    url: "/api/qywechat/oAuth2Qw",
    method: "get",
  });
}

export function getCustomer() {
  return request({
    url: "/api/qywechat/getYuanNeiCustomer",
    method: "get",
  });
}

export function getQwCustomer(param) {
  return request({
    url: "/api/qywechat/getQwCustomer",
    method: "post",
    data: param,
  });
}

export function getQwAndYuanNeiCustomer(param) {
  return request({
    url: "/api/qywechat/getQwAndYuanNeiCustomer",
    method: "post",
    data: param,
  });
}

export function getStaffsInfo(param) {
  return request({
    url: "/api/qywechat/getStaffsInfo",
    method: "post",
    data: param,
  });
}

export function out(authorization) {
  return request({
    url: "/api/qywechat/loginOut",
    method: "post",
    headers: {
      authorization: authorization,
    },
  });
}
// 医院租用客莱宝过期时间
export function getDaysRemaining(authorization) {
  return request({
    url: "/api/qywechat/auth_log/daysRemaining",
    method: "get",
    headers: {
      authorization: authorization,
    },
  });
}

/** 获取agentConfig所需的数据*/
export function getAgent(authorization) {
  return request(
    {
      url: "/api/qywechat/auth_log/getAgent",
      method: "get",
      headers: {
        authorization: authorization,
      },
    },
    true
  );
}

/** 获取agentConfig所需的数据*/
export function getToken(code) {
  return request(
    {
      url: `/api/qywechat/loginUser?code=${code}`,
      method: "get",
      // headers: {
      //   "authorization": authorization
      // }
    },
    true
  );
}

/**获取当前系统信息 0经典;  1云医美1.0； 2云医美4.0； 3客云 */
export function getCheckSystemApi() {
  return request({
    url: `/api/qywechat/checkSystem`,
    method: "GET",
  },true);
}
